import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CoreModule } from 'app/modules/core/core.module';
import { MessagesComponent } from 'app/layout/common/messages/messages.component';


@NgModule({
    declarations: [
        MessagesComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,
        OverlayModule,
        PortalModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        CoreModule
    ],
    exports     : [
        MessagesComponent
    ]
})
export class MessagesModule
{
}
